import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { LineClamp } from '../../../global/commonStyle';

const DropHeader = styled.div<{ applyPaddingTop?: boolean }>`
  display: flex;
  justify-content: space-between;
  padding: var(--space-6) var(--space-14) var(--space-6) var(--space-10);
  position: relative;
  border-bottom: 0.5px solid var(--border-primary);
  margin-top: var(--space-4);
  ${mobile_xl(css`
    background-color: var(--background-secondary);
    margin: var(--space-4) var(--space-10) var(--space-0);
    border: 0.5px solid var(--border-primary);
    border-radius: var(--border-radius-8);
    padding-left: var(--space-36);
  `)};
  ${(props) =>
    props.applyPaddingTop &&
    css`
      padding-top: var(--space-10);
      margin-top: var(--space-0);
    `}
`;
const InputArea = styled.input`
  max-width: 100%;
  width: 116px;
  ${LineClamp(1)}
  ${Typography.body_md}
  color: var(--text-primary);
  background-color: var(--background-primary);
  margin: var(--space-0);
  padding: var(--space-0);
  border: none;

  &:focus {
    outline: none;
  }
  .placeholder {
    color: var(--text-secondary);
  }
  ${mobile_xl(css`
    max-width: 297px;
    width: 100%;
    background-color: var(--background-secondary);
  `)}
`;
export { DropHeader, InputArea };
